import LocalOfferIcon from "@mui/icons-material/LocalOffer";

export const AddTagsToolConfig = (onClick) => ({
  name: "ADD TAGS",
  tool: "AddTags",
  icon: (
    <div onClick={onClick}>
      <LocalOfferIcon />
    </div>
  ),
});